import { BellIcon, MagnifyingGlassIcon } from "@phosphor-icons/react";
import { ThemeSwitch, useTheme } from "components/provider/theme";
import { Input } from 'antd';

type User = {
    avatar_id: number | null;
    birthday: string;
    created_at: string;
    deleted_at: string | null;
    email: string;
    fullname: string;
    gender: number;
    id: number;
    invoice_detail: any;
    is_active: number;
    is_stop: number;
    manager_email: string | null;
    manager_fullname: string | null;
    manager_phone: string | null;
    parent_id: number;
    phone: string;
    reset_pass_token: string;
    role: number;
    status: number;
    token_active: string;
    type: number;
    updated_at: string;
    username: string;
};
const { Search } = Input;
const ActiveAccountHeader = () => {
    const user: any = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData') || '{}') : null;
    const { theme } = useTheme()
    return (
        <div className="flex items-center justify-between px-4 h-[64px] gap-4">
            <Input addonBefore={<MagnifyingGlassIcon fill={theme === 'light' ? '' : '#fff'} />} placeholder="Search..." style={{ width: '35%', backgroundColor: "white !important" }} />
            <ThemeSwitch />
            <BellIcon size={24} fill={theme === 'light' ? '' : '#fff'} className="hover:cursor-pointer"/>
            <div className="flex flex-col items-start justify-center h-[64px]"
                style={{ lineHeight: '1.2' }}>
                <p className={`text-[16px] font-bold ${theme === 'light' ? 'text-gray-800' : 'text-white'} !m-0 h-[16px]`}>
                    {user && user.fullname ? user.fullname : "User Dashboard"}
                </p>
                <p className={`text-sm text-gray-400 !m-0 h-1/2`}>
                    {user && user.email ? user.email : "No email provided"}
                </p>
            </div>
            <button
                className="!m-0 cursor-pointer !text-white h-1/2 flex items-center justify-center px-4 py-2 rounded-lg bg-red-500 hover:bg-red-700 transition-colors"
                onClick={() => {
                    localStorage.removeItem('user');
                    localStorage.removeItem('token');
                    localStorage.removeItem('userId');
                    window.location.href = '/login';
                    window.location.reload();
                }}
            >
                Đăng xuất
            </button>
        </div>
    );
}
export default ActiveAccountHeader;